import BaseDeliveryRoute from 'cio/routes/base-delivery';

export default class DraftRoute extends BaseDeliveryRoute {
  templateName = 'base/overview/drafts/draft';
}
